export default {
  tags: {
    handle: 'TagsConf',
    closeall: 'Close All',
    closeother: 'Close Other'
  },
  route: {
    dashboard: 'Dashboard',
    widget: 'Widget',
    permission: 'Permission',
    datatable: 'Datatable',
    components: 'Components',
    page1: 'page1',
    page2: 'page2',
    page3: 'page3',
    profile: 'Profile',
    panels: 'Panels'
  },
  app: {
    switchlang: 'Switch Language Success',
    unlock: 'UNLOCK'
  },
  login: {
    edenPart1: 'VUE',
    edenPart2: 'EDEN',
    title: 'Login Form',
    btn: 'Login',
    radioEN: 'English',
    radioZH: 'Chinese',
    forgetpwd: 'Forget Password',
    remember: 'Remember',
    userplaceholder: 'please enter lovely phoneNumber',
    pwdplaceholder: 'please enter lovely password',
    valid: {
      userexist: 'please input username!',
      pwdexist: 'please input password!'
    },
    forget_email: 'please enter email',
    forget_code: 'please enter code',
    forget_passwrd: 'please enter new password',
    confirm_passwrd: 'confirm new password',
    forget_btn: 'Confirm',
    forget_back: 'Back',
    validfaild: 'Login form does not pass !',
    pwdChanged: 'Password Reset Successfully !'
  },
  sidebarDropDown: {
    profile: 'Profile',
    lock: 'Lock',
    logout: 'Logout'
  },
  msg: {
    msg1: 'You have a new message from Sakuya.',
    msg2: 'Chekcout today eden system report.',
    msg3: 'Eden system has some new update, check it.'
  },
  dashboard: {
    sr: 'System Report',
    pch: 'Pie Chart',
    todo: 'ToDo'
  },
  lock: {
    locked: 'Eden system has been locked!',
    unlock: 'Unlock Successfully!'
  }
}
